import { connect } from 'react-redux';
import Sources from './components/Sources';
import {
  loadSources,
  loadSource,
  loadSourcesIocCountsAndIsActive,
  loadSourcesIocCounts,
  createEmptySource,
  createURLSource,
  createFileSource,
  deleteSource,
  changeSourceScope,
  activateSource,
  updateSource,
  updateFileSource,
  publishSource,
} from '../../redux/actions/source';
import {
  consumeFileData,
  consumeFeedData,
  exportFeed,
  verifyAuth,
} from '../../redux/actions/feed';
import { resetTagSearch, searchForTags } from '../../redux/actions/tags';
import { selectFeedItemFields } from '../../redux/selectors/filters';
import { selectFoundTags } from '../../redux/selectors/tags';
import {
  loadFilters,
  closeFilterSidebar,
  applyFilters,
} from '../../redux/actions/filters';
import { updateIocList } from '../../redux/actions';
import { loadMySubscriptionPlan } from '../../redux/actions/user';
import { updateTag } from '../../redux/actions';

const mapStateToProps = (state) => ({
  user: state.user.user,
  sources: state.source.sources,
  sourcesCount: state.source.sourcesCount,
  loadSourcesStatus: state.source.loadSourcesStatus,
  loadSourcesIocCountsAndIsActiveStatus:
    state.source.loadSourcesIocCountsAndIsActiveStatus,
  ThreatRankingListPagination: state.ioc.pagination,
  ThreatRankingListSorting: state.ioc.sorting,
  threatRankingListFilters: state.ioc.filters,
  activateSourceStatus: state.source.activateSourceStatus,
  consumeStatus: state.feed.consumeStatus,
  foundTags: selectFoundTags(state),
  searchStatus: state.tags.searchStatus,
  feedTable: state.feed.tableData,
  feedItemFields: selectFeedItemFields(state),
  testStatus: state.feed.testStatus,
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
});

const mapDispatchToProps = {
  loadSources,
  loadSource,
  loadSourcesIocCountsAndIsActive,
  loadSourcesIocCounts,
  createFileSource,
  createEmptySource,
  createURLSource,
  updateSource,
  updateFileSource,
  deleteSource,
  changeSourceScope,
  activateSource,
  resetTagSearch,
  searchForTags,
  consumeFileData,
  consumeFeedData,
  exportFeed,
  verifyAuth,
  loadFilters,
  closeFilterSidebar,
  applyFilters,
  updateIocList,
  publishSource,
  loadMySubscriptionPlan,
  updateTag,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sources);
